import React from 'react'

interface SectionTitleProps {
  children: React.ReactNode
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
  className?: string
  noMargin?: boolean // Para evitar margen cuando está dentro de contenedores flex
}

/**
 * Componente SectionTitle - Título de sección con icono opcional
 * Usado para títulos de secciones en formularios
 */
const SectionTitle: React.FC<SectionTitleProps> = ({
  children,
  icon: Icon,
  className = '',
  noMargin = false,
}) => {
  const marginClass = noMargin ? '' : 'mb-4'
  
  return (
    <h3 className={`flex items-center gap-2 text-lg font-semibold text-custom-blue ${marginClass} ${className}`}>
      {Icon && (
        <Icon className="h-5 w-5 text-custom-blue flex-shrink-0" />
      )}
      <span>{children}</span>
    </h3>
  )
}

export default SectionTitle

